import { render, staticRenderFns } from "./selectfather.vue?vue&type=template&id=6f0942ea&scoped=true&"
import script from "./selectfather.vue?vue&type=script&lang=js&"
export * from "./selectfather.vue?vue&type=script&lang=js&"
import style0 from "./selectfather.vue?vue&type=style&index=0&id=6f0942ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0942ea",
  null
  
)

export default component.exports